import { render, staticRenderFns } from "./ACLRuleShow.vue?vue&type=template&id=321351c6&"
import script from "./ACLRuleShow.vue?vue&type=script&lang=js&"
export * from "./ACLRuleShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports